import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "../../config/api";

function IntroAdmin() {
  const [data, setData] = useState({
    firstName: "",
    lastName: "",
    roles: [],
    description: "",
    resumeUrl: "",
    model3DUrl: "",
  });
  const [roleInput, setRoleInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get(`${API_URL}/intro`);
      if (response.data.success) {
        setData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching intro:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: "", text: "" });

    try {
      const token = localStorage.getItem("adminToken");
      const response = await axios.put(`${API_URL}/intro`, data, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.data.success) {
        setMessage({ type: "success", text: "Intro updated successfully!" });
      }
    } catch (error) {
      setMessage({
        type: "error",
        text: error.response?.data?.message || "Update failed",
      });
    } finally {
      setLoading(false);
    }
  };

  const addRole = () => {
    if (roleInput.trim() && !data.roles.includes(roleInput.trim())) {
      setData({ ...data, roles: [...data.roles, roleInput.trim()] });
      setRoleInput("");
    }
  };

  const removeRole = (index) => {
    setData({ ...data, roles: data.roles.filter((_, i) => i !== index) });
  };

  return (
    <div className="space-y-4 sm:space-y-6">
      <h2 className="text-xl sm:text-2xl font-light mb-4 sm:mb-6">
        Edit Intro Section
      </h2>

      <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
          <div>
            <label className="block text-white/60 text-xs sm:text-sm mb-2">
              First Name
            </label>
            <input
              type="text"
              value={data.firstName}
              onChange={(e) => setData({ ...data, firstName: e.target.value })}
              className="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-white/[0.05] border border-white/[0.1] rounded-xl text-white text-sm sm:text-base
                       focus:outline-none focus:border-white/30 transition-all"
              required
            />
          </div>

          <div>
            <label className="block text-white/60 text-xs sm:text-sm mb-2">
              Last Name
            </label>
            <input
              type="text"
              value={data.lastName}
              onChange={(e) => setData({ ...data, lastName: e.target.value })}
              className="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-white/[0.05] border border-white/[0.1] rounded-xl text-white text-sm sm:text-base
                       focus:outline-none focus:border-white/30 transition-all"
              required
            />
          </div>
        </div>

        <div>
          <label className="block text-white/60 text-xs sm:text-sm mb-2">
            Roles (typing animation)
          </label>
          <div className="flex gap-2 mb-2">
            <input
              type="text"
              value={roleInput}
              onChange={(e) => setRoleInput(e.target.value)}
              onKeyPress={(e) =>
                e.key === "Enter" && (e.preventDefault(), addRole())
              }
              className="flex-1 px-3 sm:px-4 py-2.5 sm:py-3 bg-white/[0.05] border border-white/[0.1] rounded-lg sm:rounded-xl text-white text-sm sm:text-base
                       focus:outline-none focus:border-white/30 transition-all"
              placeholder="Add a role"
            />
            <button
              type="button"
              onClick={addRole}
              className="px-4 sm:px-6 py-2.5 sm:py-3 bg-white/10 border border-white/20 rounded-lg sm:rounded-xl hover:bg-white/20 transition-all text-sm sm:text-base"
            >
              Add
            </button>
          </div>
          <div className="flex flex-wrap gap-2">
            {data.roles.map((role, index) => (
              <div
                key={index}
                className="px-4 py-2 bg-white/10 border border-white/20 rounded-lg flex items-center gap-2"
              >
                <span>{role}</span>
                <button
                  type="button"
                  onClick={() => removeRole(index)}
                  className="text-red-400 hover:text-red-300"
                >
                  ×
                </button>
              </div>
            ))}
          </div>
        </div>

        <div>
          <label className="block text-white/60 text-xs sm:text-sm mb-2">
            Description
          </label>
          <textarea
            value={data.description}
            onChange={(e) => setData({ ...data, description: e.target.value })}
            rows="4"
            className="w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-white/[0.05] border border-white/[0.1] rounded-lg sm:rounded-xl text-white text-sm sm:text-base
                     focus:outline-none focus:border-white/30 transition-all resize-none"
            required
          />
        </div>

        <div>
          <label className="block text-white/60 text-xs sm:text-sm mb-2">
            Resume
          </label>
          <div className="space-y-2">
            <p className="text-white/40 text-xs sm:text-sm">
              Resume is stored in /public/Final_Resume_wp.pdf
            </p>
            <a
              href="/Final_Resume_wp.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-blue-400 hover:text-blue-300 block"
            >
              View current resume →
            </a>
          </div>
        </div>

        {message.text && (
          <div
            className={`p-4 rounded-lg ${
              message.type === "success"
                ? "bg-green-500/10 border border-green-500/20 text-green-400"
                : "bg-red-500/10 border border-red-500/20 text-red-400"
            }`}
          >
            {message.text}
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          className="w-full py-2.5 sm:py-3 bg-white/10 border border-white/20 rounded-lg sm:rounded-xl hover:bg-white/20 
                   transition-all disabled:opacity-50 disabled:cursor-not-allowed text-sm sm:text-base"
        >
          {loading ? "Updating..." : "Update Intro"}
        </button>
      </form>
    </div>
  );
}

export default IntroAdmin;
